const en = {
  passwordMismatch: 'New password and confirmation do not match.',
  currentPasswordRequired: 'Enter your current password to set a new one.',
  updateSuccess: 'Profile updated.',
  updateFailed: 'Failed to update profile',
  fullName: 'Full Name',
  changePasswordOptional: 'Change Password (optional)',
  currentPasswordPlaceholder: 'Current password',
  newPasswordPlaceholder: 'New password',
  confirmNewPasswordPlaceholder: 'Confirm new password',
  saveChanges: 'Save Changes',
};

const de = {
  passwordMismatch: 'Neues Passwort und Bestätigung stimmen nicht überein.',
  currentPasswordRequired: 'Geben Sie Ihr aktuelles Passwort ein, um ein neues festzulegen.',
  updateSuccess: 'Profil aktualisiert.',
  updateFailed: 'Profil konnte nicht aktualisiert werden',
  fullName: 'Vollständiger Name',
  changePasswordOptional: 'Passwort ändern (optional)',
  currentPasswordPlaceholder: 'Aktuelles Passwort',
  newPasswordPlaceholder: 'Neues Passwort',
  confirmNewPasswordPlaceholder: 'Passwort bestätigen',
  saveChanges: 'Änderungen speichern',
};

const profileSettingsModal = { en, de };
export default profileSettingsModal;
